import React from 'react';
import './index.scss';
import { PlainText } from '../plainText/plainText';
import aiToolsNavLogo from '../../images/ai-tools-nav.png';
import rightIcon from '../../images/arrow-right.png';

const PlatformActionList = () => {
    // 权限控制
    const hasAIToolsPermission =
        Number(
            (window as unknown as { pageData: { enterprise_setting: { setup: { enable_ai_tools: number } } } }).pageData
                ?.enterprise_setting?.setup?.enable_ai_tools,
        ) === 1;

    if (!hasAIToolsPermission || location.pathname.startsWith('/ai-tools')) {
        return null;
    }

    return (
        <div className="platform-action-list">
            <div className="to-ai-tools">
                <a href="/ai-tools" target="_blank" rel="noreferrer" className="btn">
                    <img className="ai-tools-logo" src={aiToolsNavLogo} alt="ai-tools-logo" />
                    <PlainText>去 AI 工具平台</PlainText>
                    <img className="arrow-right" src={rightIcon} />
                </a>
            </div>
        </div>
    );
};

export { PlatformActionList };
